import AnnouncementsConfigPage from "../../pages/AnnouncementConfig/announcements-config.page";
import CreateEditAudiencePage from "../../pages/AnnouncementConfig/create-edit-audience.page";
import AnnouncementsPage from "../../pages/Announcements/announcements.page";
import DashboardPage from "../../pages/Dashboard/dashboard.page";
import FileConfigurationPage from "../../pages/FileConfiguration/file-configuration.page";
import FilesListPage from "../../pages/FileConfiguration/files.page";
import TicketsPage from "../../pages/Tickets/tickets.page";
import { ROUTE_ANNOUNCEMENTS, ROUTE_ANNOUNCEMENTS_CONFIG, ROUTE_ANNOUNCEMENTS_CONFIG_PARAM, ROUTE_CREATE_AUDIENCE, ROUTE_DASHBOARD, ROUTE_EDIT_AUDIENCE, ROUTE_FILE_CONFIGURATION, ROUTE_FILE_LIST_CONFIGURATION, ROUTE_TICKETS, ROUTE_VIEW_AUDIENCE_QUERY } from "./ui.routes";
export const PERMITTED_ROUTES: any[] = [
  {
    name: "Landing",
    route: ROUTE_DASHBOARD,
    component: DashboardPage,
  },
  {
    name: "Tickets",
    route: ROUTE_TICKETS,
    component: TicketsPage,
  },
  {
    name: "ROUTE_FILE_CONFIGURATION",
    route: ROUTE_FILE_CONFIGURATION,
    component: FileConfigurationPage,
  },
  {
    name: "ROUTE_FILE_LIST_CONFIGURATION",
    route: ROUTE_FILE_LIST_CONFIGURATION(':category_id', ':category_name'),
    component: FilesListPage,
  },
  {
    name: "ROUTE_ANNOUNCEMENTS",
    route: ROUTE_ANNOUNCEMENTS,
    component: AnnouncementsPage,
  },
  {
    name: "ROUTE_ANNOUNCEMENTS_CONFIG",
    route: ROUTE_ANNOUNCEMENTS_CONFIG,
    component: AnnouncementsConfigPage,
  },
  {
    name: "ROUTE_ANNOUNCEMENTS_CONFIG_PARAM",
    route: ROUTE_ANNOUNCEMENTS_CONFIG_PARAM(":tab"),
    component: AnnouncementsConfigPage,
  },
  {
    name: "ROUTE_CREATE_AUDIENCE",
    route: ROUTE_CREATE_AUDIENCE,
    component: CreateEditAudiencePage,
  },
  {
    name: "ROUTE_EDIT_AUDIENCE",
    route: ROUTE_EDIT_AUDIENCE(':id'),
    component: CreateEditAudiencePage,
  },
  {
    name: "ROUTE_VIEW_AUDIENCE_QUERY",
    route: ROUTE_VIEW_AUDIENCE_QUERY(':id'),
    component: CreateEditAudiencePage,
  },
];
